import { InformationModalLayout } from 'modules/components/layer13';
import { CustomIcon } from 'modules/components/layer00';

import React from 'react';
import * as ds from './dataService';
import { useNavigate } from 'react-router-dom';


export type RemoveDocumentModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: RemoveDocumentModalProps) => {
  const [
    fnRemoveDocument,
    { loading }
  ] = ds.useRemoveDocument();

  const navigate = useNavigate();



  return (
    <InformationModalLayout.FC
      id={props.id}
      isVisible={props.isVisible}
      loading={loading}
      handleClose={() => props.handleClose()}
      title='Remove Document'
      headerIcon={(
        <CustomIcon.large.FC
          icon='DELETE'
        />
      )}
      subTitle='Are you sure to remove document? This action cannot be undone.'
      successButton={{
        text: 'Confirm',
        handleClick: async () => {
          await fnRemoveDocument(props.id);
          navigate('..');
          props.handleClose();

        }
      }}
      cancelButton={{
        text: 'Cancel',
        handleClick: () => props.handleClose()
      }}
    />
  );
};
